import i18next from "i18next";

// Used when the caller has no t function at hand (hooks building dropdown options)
const tAdmin = (key: string): string => i18next.t(key, { ns: "admin" }) as string;

export enum OrderTypeString {
    Vehicle = "Pojazd",
    Container = "Kontener",
    Weight = "Tonaż",
  }

const orderTypeNameKeys: { [name: string]: string } = {
  [OrderTypeString.Vehicle]: "orders.typeValues.vehicle",
  [OrderTypeString.Container]: "orders.typeValues.container",
  [OrderTypeString.Weight]: "orders.typeValues.tonnage",
  // Orders without an order type (CUO special tires) - set by the API mapping
  "Specjalne": "orders.typeValues.special",
};

// Order type names come from the API in Polish - translate the known ones for display
export const translateOrderTypeName = (name: string, t: (key: string) => string = tAdmin): string =>
  orderTypeNameKeys[name] !== undefined ? t(orderTypeNameKeys[name]) : name;

const orderTypeItemNameKeys: { [name: string]: string } = {
  "solo": "orders.itemValues.solo",
  "TIR / naczepa": "orders.itemValues.tirTrailer",
  "bus": "orders.itemValues.bus",
  "Tonaż- pojazd": "orders.itemValues.tonnageVehicle",
  "Tonaż- kontener": "orders.itemValues.tonnageContainer",
  "Kontener": "orders.itemValues.container",
  "Specjalne": "orders.typeValues.special",
};

// Order type item (subtype) names come from the API in Polish - translate the default ones for display only
export const translateOrderTypeItemName = (name: string, t: (key: string) => string = tAdmin): string =>
  orderTypeItemNameKeys[name] !== undefined ? t(orderTypeItemNameKeys[name]) : name;

export enum OrderTypeNumber {
  Vehicle = 1, 
  Tonnage = 2,
  Container = 3
}